var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoticias = function SvgNoticias(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.379,
    height: 79.615,
    viewBox: "0 0 76.379 79.615"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M.647 38.513A.647.647 0 0 1 0 37.866v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647M.647 34.629A.647.647 0 0 1 0 33.982V15.858a.647.647 0 1 1 1.295 0v18.124a.647.647 0 0 1-.648.647M75.731 43.691a.647.647 0 0 1-.647-.647v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647M75.731 64.404a.65.65 0 0 1-.647-.647V45.633a.647.647 0 1 1 1.295 0v18.124a.647.647 0 0 1-.648.647M62.134 67.317h-11a.647.647 0 1 1 0-1.295h11a2.59 2.59 0 0 0 2.589-2.589V3.883a2.59 2.59 0 0 0-2.589-2.589h-47.9a2.593 2.593 0 0 0-2.589 2.589v59.55a2.593 2.593 0 0 0 2.589 2.589h11a.647.647 0 0 1 0 1.295h-11a3.89 3.89 0 0 1-3.884-3.884V3.883a3.89 3.89 0 0 1 3.884-3.884h47.9a3.887 3.887 0 0 1 3.884 3.884v59.55a3.89 3.89 0 0 1-3.884 3.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M14.888 73.79h-7.12a3.89 3.89 0 0 1-3.884-3.884v-59.55a3.89 3.89 0 0 1 3.884-3.884h.647a.647.647 0 1 1 0 1.295h-.647a2.593 2.593 0 0 0-2.589 2.589v59.55a2.593 2.593 0 0 0 2.589 2.589h7.12a.647.647 0 1 1 0 1.295M68.611 73.79h-7.12a.647.647 0 1 1 0-1.295h7.12a2.59 2.59 0 0 0 2.589-2.589v-59.55a2.59 2.59 0 0 0-2.589-2.589h-.647a.647.647 0 1 1 0-1.295h.647a3.887 3.887 0 0 1 3.884 3.884v59.55a3.89 3.89 0 0 1-3.884 3.884"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.582,
    height: 18.582,
    fill: "#ff5701",
    rx: 1,
    transform: "translate(18.125 7.767)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M28.706 17.705h-4.2a.647.647 0 0 1-.647-.647v-4.531a.647.647 0 0 1 .647-.647h4.2a2.913 2.913 0 0 1 0 5.825m-3.56-1.295h3.56a1.618 1.618 0 0 0 0-3.236h-3.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M29.357 22.236h-4.851a.65.65 0 0 1-.647-.647v-4.531a.647.647 0 0 1 .647-.647h4.855a2.913 2.913 0 0 1 0 5.826Zm-4.207-1.295h4.207a1.618 1.618 0 0 0 0-3.236H25.15ZM24.502 13.175h-1.291a.647.647 0 1 1 0-1.295h1.295a.647.647 0 1 1 0 1.295Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M24.502 22.237h-1.291a.647.647 0 1 1 0-1.295h1.295a.647.647 0 1 1 0 1.295ZM25.8 12.527a.647.647 0 0 1-.647-.647v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647M28.389 12.527a.647.647 0 0 1-.647-.647v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647M25.8 24.178a.647.647 0 0 1-.647-.647v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647M28.389 24.178a.647.647 0 0 1-.647-.647v-1.295a.647.647 0 1 1 1.295 0v1.295a.647.647 0 0 1-.648.647"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M43 14.001h15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.251 14.888H42.72a.647.647 0 0 1 0-1.295h15.531a.647.647 0 1 1 0 1.295"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M43 21.001h15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.251 21.361H42.72a.647.647 0 0 1 0-1.295h15.531a.647.647 0 1 1 0 1.295"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M18.124 33.011h40.131"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.254 33.659H18.123a.647.647 0 1 1 0-1.295h40.131a.647.647 0 1 1 0 1.295"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M18.124 39.484h40.131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.254 40.132H18.123a.647.647 0 1 1 0-1.295h40.131a.647.647 0 1 1 0 1.295"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M18.124 45.957h40.131"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.254 46.605H18.123a.647.647 0 1 1 0-1.295h40.131a.647.647 0 1 1 0 1.295"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M25.245 66.669v7.12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M25.244 74.437a.65.65 0 0 1-.647-.647v-7.123a.647.647 0 1 1 1.295 0v7.12a.647.647 0 0 1-.648.65"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M38.19 66.669V71.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M38.189 71.848a.65.65 0 0 1-.647-.647v-4.534a.647.647 0 1 1 1.295 0v4.531a.647.647 0 0 1-.648.65"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M51.136 66.669v7.12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M51.135 74.437a.65.65 0 0 1-.647-.647v-7.123a.647.647 0 1 1 1.295 0v7.12a.647.647 0 0 1-.648.65M44.662 67.317H31.716a.647.647 0 1 1 0-1.295h12.946a.647.647 0 1 1 0 1.295M25.243 79.616a3.236 3.236 0 1 1 3.236-3.236 3.24 3.24 0 0 1-3.236 3.236m0-5.178a1.942 1.942 0 1 0 1.942 1.942 1.944 1.944 0 0 0-1.942-1.942M38.189 77.026a3.236 3.236 0 1 1 3.236-3.236 3.24 3.24 0 0 1-3.236 3.236m0-5.178a1.942 1.942 0 1 0 1.942 1.942 1.944 1.944 0 0 0-1.942-1.942"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M51.135 79.616a3.236 3.236 0 1 1 3.236-3.236 3.24 3.24 0 0 1-3.236 3.236m0-5.178a1.942 1.942 0 1 0 1.942 1.942 1.944 1.944 0 0 0-1.942-1.942"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M18 53.001h9v8h-9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M27.185 61.492h-9.062a.647.647 0 0 1-.647-.647v-7.77a.647.647 0 0 1 .647-.647h9.062a.646.646 0 0 1 .647.647v7.767a.647.647 0 0 1-.647.65m-8.415-1.295h7.767v-6.472H18.77Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M34 53.001h9v8h-9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M42.72 61.492h-9.062a.647.647 0 0 1-.647-.647v-7.77a.647.647 0 0 1 .647-.647h9.062a.646.646 0 0 1 .647.647v7.767a.647.647 0 0 1-.647.65m-8.415-1.295h7.767v-6.472h-7.767Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5701",
    d: "M49 53.001h9v8h-9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d161b",
    d: "M58.255 61.492h-9.062a.647.647 0 0 1-.647-.647v-7.77a.647.647 0 0 1 .647-.647h9.062a.646.646 0 0 1 .647.647v7.767a.647.647 0 0 1-.647.65m-8.415-1.295h7.767v-6.472H49.84Z"
  })));
};
export default SvgNoticias;